import { render, staticRenderFns } from "./MarketingCards.vue?vue&type=template&id=fb3ad990&scoped=true"
import script from "./MarketingCards.vue?vue&type=script&lang=ts"
export * from "./MarketingCards.vue?vue&type=script&lang=ts"
import style0 from "./MarketingCards.vue?vue&type=style&index=0&id=fb3ad990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3ad990",
  null
  
)

export default component.exports